import React from "react";
import { reduxForm, formValueSelector } from "redux-form";
import { Field, FieldArray } from "redux-form";
import {
  requiredValidate,
  phoneNumberValidate,
  emailValidate,
} from "../helpers";
import { Loader, FormField } from "pickups-ui-library";
import { Button, Alert } from "reactstrap";

const RegisterUser = (props) => {
  const { handleSubmit, onSubmit, onCancel, pristine, submitting, error } =
    props;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Field
        name="fname"
        type="text"
        component={FormField}
        label="First Name"
        placeholder=""
        validate={[requiredValidate]}
      />
      <Field
        name="lname"
        type="text"
        component={FormField}
        label="Last Name"
        placeholder=""
        validate={[requiredValidate]}
      />
      <Field
        name="email"
        type="text"
        component={FormField}
        label="Email"
        placeholder=""
        validate={[requiredValidate, emailValidate]}
      />
      <Field
        name="phoneNumber"
        type="phone"
        component={FormField}
        label="Phone Number"
        placeholder=""
        validate={[requiredValidate, phoneNumberValidate]}
      />
      <Field
        name="password"
        type="password"
        component={FormField}
        label="Password"
        placeholder=""
        validate={[requiredValidate]}
      />
      {error && <Alert color={"danger"}>{error}</Alert>}
      <div className={"pt-3"}>
        <Button type="submit" disabled={pristine || submitting || error} block>
          {" "}
          {submitting ? <Loader color="#fff" /> : "Register"}{" "}
        </Button>
      </div>
    </form>
  );
};

export default RegisterUser;
